import { CSSProperties } from 'react'

const styles: {
  root: CSSProperties
  row: CSSProperties
  line: CSSProperties
} = {
  root: {
    width: '100%',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
  },
  line: {
    flex: 1,
    height: 5,
    backgroundColor: 'white',
    marginLeft: '10%',
    marginRight: '10%',
    borderRadius: 2,
  },
}

export default styles
